import { useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { fetchConfig } from './api.utils';

export const useAllowedProjects = (publisherId?: string) => {
  const axios = useAxios();
  const customHeaders = publisherId ? { 'x-publishers': publisherId } : undefined;
  return useQuery({
    ...fetchConfig.list,
    queryKey: [EQueryKeys.ALLOWED_PROJECTS, publisherId],
    queryFn: async () => {
      return await axios.patch(
        `/dashboard/v2/user/allowed-projects`,
        customHeaders
      );
    }
  });
}; 